import { AccountingSubNav } from '../components/AccountingSubNav';
import { Gstr1SummaryReport } from '@/features/accounts/components/reports/Gstr1SummaryReport';

export function AccountingGstr1Page() {
  return (
    <div>
      <AccountingSubNav />
      <div className=" pb-16">
        <Gstr1SummaryReport />
      </div>
    </div>
  );
}
